<template>
  <div class="hc-compact-page hc-documents-page">
    <!-- Header Card -->
        <PageHeader icon="fas fa-folder-open">
      <template #title>
        Dokumen Pasien {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola dan arsipkan berkas serta dokumen medis pasien
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                v-b-modal.modal-form
                v-if="manipulateBtn == true">
                <i class="fas fa-plus"></i>
                <span>Tambah Dokumen</span>
              </b-button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <div class="row" v-if="page == 'list'">
          <div class="col-md-12">
            <Card>
              <template v-slot:body>
                <modern-filter-bar
                  embedded
                  :btn-active="btntype"
                  :period-options="documentPeriodOptions"
                  :search-text.sync="find"
                  search-placeholder="Cari pasien"
                  @timeseries-click="selectDocumentPeriod"
                  @search-keyup="filterByName"
                ></modern-filter-bar>

                <div
                  class="row align-content-center"
                  v-if="tableSide == false && dataSign == true"
                >
                  <div class="col-12 text-center">
                    <h6 class="text-danger">Dokumen Tidak Ditemukan</h6>
                  </div>
                  <div class="col-12 text-center">
                    <small
                      >Silahkan Tambah Dokumen Terlebih Dahulu,<a
                        @click="handleList"
                        class="text-primary"
                        >Kembali Ke Tabel</a
                      ></small
                    >
                  </div>
                </div>

                <div v-if="tableSide == true">
                  <!-- <div class="row" v-if="tableHide == false">
                    <div class="col-md-12">
                      <Table purpose="master" :listData="listData"></Table>
                    </div>
                    <hr />
                  </div> -->

                  <!-- Sign for empty daily document -->
                  <div class="row" v-if="tableHide == true">
                    <div class="col-12 text-center">
                      <h6 class="text-danger">Tidak Ada Dokumen Baru</h6>
                    </div>
                    <div class="col-12 text-center">
                      <small>Silahkan Cari Untuk Melihat Dokumen Pasien</small>
                    </div>
                  </div>
                </div>

                <medhop-data-table
                  summary-title="Dokumen Pasien"
                  :items="documents"
                  :fields="fields"
                  striped
                  hover
                  empty-text="Belum ada dokumen pasien"
                >
                  <template #cell(number)="data">
                    {{ (currentPage - 1) * perPage + data.index + 1 }}
                  </template>
                  <template #cell(title_file)="data">
                    <div class="d-flex align-items-center">
                      <span class="d-inline-flex align-items-center justify-content-center mr-3 rounded bg-light-info" style="width:34px;height:34px">
                        <i class="fas fa-file-medical text-info"></i>
                      </span>
                      <span>{{ data.item.title_file || data.item.title || "Dokumen medis" }}</span>
                    </div>
                  </template>
                  <template #cell(actions)="data">
                    <b-button
                      size="sm"
                      class="btn-info"
                      title="Lihat dokumen pasien"
                      @click="handleDetail(data.item.patient_id, data.item)"
                    ><i class="fas fa-eye px-0"></i></b-button>
                  </template>
                </medhop-data-table>
                <div class="d-flex justify-content-end">
                  <medhop-pagination
                    v-if="documents.length != 0"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    class="mt-4"
                    @page-click="pageOnClick"
                  ></medhop-pagination>
                </div>
              </template>
            </Card>
          </div>
        </div>

        <div class="row" v-if="page == 'detail'">
          <div class="col-md-12" v-if="dataLoaded == true">
            <Card>
              <template v-slot:body>
                <div v-if="detailEmpty == true">
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <span>Dokumen Tidak Tersedia</span>
                    </div>
                  </div>
                </div>
                <div v-if="detailEmpty == false">
                  <div class="row align-items-center">
                    <div class="col-md-12 d-inline pb-1">
                      <b-alert show variant="primary mb-0">
                        <span
                          class="text-teal"
                          style="cursor: pointer"
                          @click="handleList"
                          >Dokumen</span
                        >
                        <!-- <i class="fas fa-fw fa-arrow-right text-light"></i> -->
                        <i class="fas fa-sm fa-circle text-light px-2"></i>
                        <span class="text-teal">{{
                          list != [] ? list[0].patient_name : ""
                        }}</span>
                        <!-- <i class="fas fa-fw fa-arrow-right text-light"></i> -->
                        <i class="fas fa-sm fa-circle text-light px-2"></i>
                        <span class="font-weight-bold"> Detail</span>
                      </b-alert>
                    </div>
                  </div>
                  <modern-filter-bar
                    embedded
                    :show-timeseries="false"
                    :search-text.sync="filter.title"
                    search-placeholder="Cari dokumen"
                    class="mt-3"
                    @search-keyup="filterDocumentByName"
                  ></modern-filter-bar>
                  <div class="row mt-1">
                    <div
                      class="col-md-2 col-6 my-2 d-flex justify-content-center"
                      v-for="(attachment, index) in attachments"
                      :key="attachment.id"
                    >
                      <!-- <a download="file" :href="attachments[index]" > -->
                      <div
                        class="card border-0 card-document"
                        @dblclick="newWindow(attachments[index])"
                      >
                        <div
                          class="card-body p-1 d-flex justify-content-start align-items-center"
                          style="cursor: pointer"
                        >
                          <div class="row py-2 px-0">
                            <div
                              class="col-md-12 d-flex justify-content-end p-0 m-0"
                            >
                              <b-dropdown
                                size="sm"
                                variant="link"
                                toggle-class="text-decoration-none"
                                no-caret
                                class="p-0 m-0"
                                dropright
                              >
                                <template #button-content>
                                  <i
                                    class="fas fa-lg fa-ellipsis-v mr-2 text-dark"
                                  ></i>
                                </template>
                                <b-dropdown-item
                                  @click="detailDocument(dataId[index])"
                                  ><i
                                    class="fas fa-md fa-eye text-success mt-1 mr-2"
                                  ></i>
                                  Detail</b-dropdown-item
                                >
                                <b-dropdown-item
                                  @click="editDocument(dataId[index])"
                                  ><i
                                    class="fas fa-md fa-edit text-success mt-1 mr-2"
                                  ></i>
                                  Edit</b-dropdown-item
                                >
                                <b-dropdown-item
                                  @click="deleteDocument(dataId[index])"
                                  ><i
                                    class="fas fa-md fa-trash-alt text-danger mt-1 mr-2"
                                  ></i>
                                  Hapus</b-dropdown-item
                                >
                              </b-dropdown>
                            </div>
                            <div
                              class="col-md-12 d-flex justify-content-center px-0 pb-1"
                            >
                              <i
                                class="fas fa-fw fa-7x fa-file"
                                v-if="
                                  fileExt[index] != 'png' &&
                                  fileExt[index] != 'jpg' &&
                                  fileExt[index] != 'jpeg'
                                "
                              ></i>

                              <div
                                class="d-flex justify-content-center align-items-center"
                                v-if="
                                  fileExt[index] == 'png' ||
                                  fileExt[index] == 'jpg' ||
                                  fileExt[index] == 'jpeg'
                                "
                              >
                                <div
                                  style="
                                    height: 170px;
                                    width: 170px;
                                    position: relative;
                                  "
                                >
                                  <img
                                    :src="attachments[index]"
                                    class="image"
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-md-12 d-flex justify-content-center pt-1"
                            >
                              <span
                                class="font-weight-light text-center text-dark"
                              >
                                {{
                                  fileNameDetail[index].length > 10
                                    ? fileNameDetail[index]
                                    : fileNameDetail[index]
                                }}
                                <!-- {{fileNameDetail[index]}} -->
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- </a> -->
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center mt-5">
                  <medhop-pagination
                    v-if="attachments.length != 0"
                    v-model="currentPageDetail"
                    :total-rows="totalRowsDetail"
                    :per-page="perPageDetail"
                    @page-click="pageOnClickDetail"
                    class="mt-4"
                  ></medhop-pagination>
                </div>

                <b-button
                  size="sm"
                  class="btn-primary mt-3"
                  @click="handleList"
                  v-if="documentsLoad == false"
                >
                  Kembali
                </b-button>
                <b-button
                  size="sm"
                  class="btn-primary mt-3"
                  @click="handleAllDocument"
                  v-if="documentsLoad == true"
                >
                  Kembali
                </b-button>
              </template>
            </Card>
          </div>
        </div>

        <!-- add -->
        <Form @refreshDocuments="getDocument" :patientData="patientData" />
        <!-- edit -->
        <FormEdit :form="form"></FormEdit>
        <!-- detail -->
        <ModalDetail :data="detail"></ModalDetail>
      </div>
    </div>
  </div>
</template>

<script>
import Table from "@/component/patients/DocumentHistory.vue";
import module from "@/core/modules/CrudModule.js";
import Card from "@/view/content/Card.vue";
import Form from "@/component/patients/DocumentForm.vue";
import FormEdit from "@/component/patients/DocumentEdit.vue";
import ModalDetail from "@/component/patients/DocumentDetail.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import moment from "moment";
import { debouncer } from "@/core/modules/Helper.js";

export default {
  data() {
    return {
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name,
      // data
      tableSide: true, //for showing table
      dataSign: false, //find or not data notification
      dataLoaded: false, //data load status
      documents: [],
      find: "",
      date: "",
      page: "list",
      list: "",
      listData: [],
      documentsLoad: false,
      tableHide: false, //for hide only table nnot side
      allDayDetail: "false",
      attachments: [],
      fileName: [],
      fileNameDetail: [],
      fileExt: [],
      patientName: [],
      attachment: [],
      showAllDocument: false, //show all document status
      dataId: [],
      detailEmpty: false,
      btntype: {
        all: false,
        today: true,
      },
      documentPeriodOptions: [
        { value: "today", label: "Dokumen Hari Ini" },
        { value: "all", label: "Semua Dokumen" },
      ],

      // latest id
      latestId: "",
      editId: "",
      // access management
      manipulateBtn: false,
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "display_check_date",
          label: "Tanggal",
          sortable: true,
        },
        {
          key: "patient_name",
          label: "Nama Pasien",
          sortable: true,
        },
        {
          key: "title_file",
          label: "Nama Dokumen",
          sortable: true,
        },
        { key: "description", label: "Keterangan" },
        { key: "actions", label: "Aksi" },
      ],
      // Form
      form: {
        title: "",
        description: "",
      },
      patientData: {
        id: "",
        name: "",
      },
      filter: {
        title: "",
      },
      detail: {},
      perPage: 20,
      currentPage: 1,
      totalRows: 0,

      perPageDetail: 20,
      currentPageDetail: 1,
      totalRowsDetail: 0,
    };
  },

  components: {
    Card,
    Form,
    FormEdit,
    ModalDetail,
    Table,
  },

  methods: {
    selectDocumentPeriod(period) {
      if (period === "all") {
        this.handleAllDocument();
        return;
      }
      this.handleList();
    },
    pageOnClick(evt, page) {
      evt.preventDefault();
      this.currentPage = page;
      if (this.showAllDocument == true) {
        this.getAllDocument();
      } else {
        this.getDocuments();
      }
    },
    pageOnClickDetail(evt, page) {
      evt.preventDefault();
      this.currentPageDetail = page;
      this.getDocument(this.patientData.id);
    },
    newWindow(url) {
      window.open(url);
    },
    handleDate() {
      var currentDate = new Date();
      var day = currentDate.getDate();
      var month = currentDate.getMonth() + 1;
      var year = currentDate.getFullYear();
      let date = day + "-" + month + "-" + year;
      return date;
    },
    handleAllDocument() {
      this.dataLoaded = false;
      this.tableHide = true;
      this.tableSide = false;
      this.dataSign = false;
      this.showAllDocument = true;
      this.documentsLoad = true;
      this.find = "";
      this.page = "list";

      // btn type
      this.btntype.all = true;
      this.btntype.today = false;
      this.getAllDocument();
      this.patientData.id = "";
      this.patientData.name = "";

      this.currentPageDetail = 1;
      this.totalRowsDetail = 0;
      this.filter.title = "";
    },
    handleDetail(id, data) {
      this.patientData.id = id;
      this.patientData.name = data.patient_name;
      this.dataLoaded = false;
      this.page = "detail";
      this.latestId = id;

      this.getDocument(id);
    },
    // handleToday(){
    //   this.dataLoaded = false
    //   this.tableHide = true
    //   this.tableSide = false
    //   this.dataSign = false
    //   this.showAllDocument =
    //   this.find = ""
    //   this.page = "list";
    //   this.getAllDocument()
    // },
    handleList() {
      this.dataLoaded = false;
      this.tableHide = false;
      this.tableSide = true;
      this.dataSign = false;
      this.showAllDocument = false;
      this.documentsLoad = false;
      this.find = "";
      this.page = "list";
      // btn type
      this.btntype.today = true;
      this.btntype.all = false;
      this.getDocuments();
      this.patientData.id = "";
      this.patientData.name = "";

      this.currentPageDetail = 1;
      this.totalRowsDetail = 0;
      this.filter.title = "";
    },

    async getDocuments() {
      this.fileName = [];
      this.patientName = [];
      let filterParams = ``;
      let response = await module.pagination(
        "documents",
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      );
      this.documents = response.data;
      let pagination = response.meta.pagination;
      this.totalRows = pagination.total;
      this.dataLoaded = true;

      // table list daily

      this.listData = await module.get("documents-list");

      let a;
      let b;
      let arr = [];
      let arrFile = [];

      this.listData.forEach((el) => {
        let indexArr = arr.findIndex((x) => x.patient_id == el.patient_id);

        if (indexArr == -1) {
          el.fileArr = [];
          el.file_name = [];
          let name = el.files.split("$");
          el.file_name.push(name[1].split("_").join(" "));
          el.fileArr.push(el.files);

          arr.push(el);
        } else {
          let name = el.files.split("$");
          arr[indexArr].file_name.push(name[1].split("_").join(" "));
          arr[indexArr].fileArr.push(el.files);
        }
      });

      this.listData = arr;

      // for (a = 0; a <= this.listData.length - 1; a++) {

      //   if(indexArr != -1){

      //     arrFile.push(this.listData[a].files)

      //   }else{
      //     arr.push(this.listData[a])

      //   }

      //   // // explode files
      //   // this.listData[a].files = this.listData[a].files.split(",");
      //   // this.listData[a]["files_name"] = [];
      //   // for (b = 0; b <= this.listData[a].files.length - 1; b++) {
      //   //   // get name files
      //   //   let dataName = this.listData[a].files[b].split("$");
      //   //   this.listData[a]["files_name"].push(dataName[1].split("_").join(" "));
      //   // }
      // }
    },

    async getDocument(id) {
      this.list = [];
      this.attachments = [];
      this.dataId = [];
      this.fileNameDetail = [];
      this.fileExt = [];

      let filterParams = `&title=${this.filter.title}`;
      let listData = await module.pagination(
        "documents/" + id + "/" + this.allDayDetail,
        `?page=${this.currentPageDetail}&page_size=${this.perPageDetail}${filterParams}`
      );

      if (listData.data) {
        this.list = listData.data;

        let pagination = listData.meta.pagination;
        this.totalRowsDetail = pagination.total;

        this.list.forEach((el) => {
          this.attachments.push(el.files);
          this.fileNameDetail.push(el.title_file);
          this.fileExt.push(el.ext);
          this.dataId.push(el.id);
        });

        this.dataLoaded = true;

        if (listData.data.length == 0) {
          this.tableHide = true;
        } else {
          this.tableHide = false;
        }
      } else {
        this.detailEmpty = true;
      }
    },

    filterByName() {
      debouncer(() => {
        this.currentPage = 1;
        this.getDocumentByName();
      }, 500);
    },
    filterDocumentByName() {
      debouncer(() => {
        this.currentPageDetail = 1;
        this.getDocument(this.patientData.id);
      }, 500);
    },
    async getDocumentByName() {
      this.currentPage = 1;
      if (this.find != "") {
        let response = await module.pagination("documents-name/" + this.find);
        let pagination = response.meta.pagination;
        this.totalRows = pagination.total;
        if (response.data.length == 0) {
          this.tableSide = false;
          this.tableHide = true;
          this.dataSign = true;
        } else {
          this.tableHide = true;
          this.tableSide = false;
          this.dataSign = false;
        }
        this.allDayDetail = "true";
        this.documents = response.data;
      } else {
        this.dataSign = false;
        this.tableSide = true;
        this.tableHide = false;
        this.allDayDetail = "false";
        this.getDocuments();
      }
    },

    async getAllDocument() {
      let filterParams = ``;
      let response = await module.pagination(
        "documents-all",
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      );
      if (response.data.length == 0) {
        this.tableSide = false;
        this.tableHide = true;
        this.dataSign = true;
      } else {
        this.tableHide = true;
        this.tableSide = false;
        this.dataSign = false;
      }
      this.allDayDetail = "true";
      this.documents = response.data;
      this.dataLoaded = true;

      let pagination = response.meta.pagination;
      this.totalRows = pagination.total;
    },
    // async getDocumentOnFolder() {
    //   if(this.find != ""){
    //     let response = await module.get("documents-name/" + this.find);
    //     this.documents = response;

    //   }else{
    //     this.getDocuments()
    //   }
    // },

    async deleteDocument(id) {
      let result = await module.delete("documents/" + id);

      if (result) {
        this.getDocument(this.latestId);
      }
    },

    async editDocument(id) {
      this.editId = id;

      let response = await module.get("documents/" + this.editId);

      this.form.id = response.id;
      this.form.title = response.title;
      this.form.description = response.description;
      this.form.patient_id = response.patient_id;
      this.form.format = response.format;
      this.form.file = response.files;
      this.form["_method"] = "put";

      this.$bvModal.show("modal-form-edit");
    },

    async detailDocument(id) {
      let response = await module.get("documents/" + id);
      this.detail = response;

      this.$bvModal.show("modal-detail");
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);

      let a;
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "3008") {
          this.manipulateBtn = true;
        }
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pasien" },
      { title: "Dokumen" },
    ]);
    this.getDocuments();
    this.setActiveMenu();
  },
};
</script>

<style scoped>
.card-document:hover {
  background-color: #e5f3ff !important;
}

/* .card-document {
  border: 2px solid #e3e3e3 !important;
} */
.color-brown {
  color: #ffe383 !important;
}

.image {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
</style>
